import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { auth } from '../firebase/firebaseConfig';

const httpLink = new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT || 'http://localhost:4001/graphql',
});

const authLink = setContext(async (_, { headers }) => {
    const currentUser = auth.currentUser;

    if (currentUser) {
        const token = await currentUser.getIdToken();
        return {
            headers: {
                ...headers,
                authorization: `Bearer ${token}`,
            },
        };
    }

    return { headers };
});

const client = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
});

export default client;
